import React, { useState, useEffect } from 'react';
import { Skeleton } from './Skeleton';
import { ToggleSwitch } from './ToggleSwitch';
import { isTauri } from '../utils/tauri';

export const AutoStartToggle: React.FC = () => {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isTauri()) { setLoading(false); return; }

    import('@tauri-apps/plugin-autostart').then(async (mod) => {
      const configured = localStorage.getItem('autostart-configured');
      const isCurrentlyEnabled = await mod.isEnabled();

      if (!configured) {
        if (!isCurrentlyEnabled) await mod.enable();
        localStorage.setItem('autostart-configured', 'true');
        setEnabled(true);
      } else {
        setEnabled(isCurrentlyEnabled);
      }
      setLoading(false);
    }).catch(() => setLoading(false));
  }, []);

  const handleToggle = async () => {
    const mod = await import('@tauri-apps/plugin-autostart');
    if (enabled) {
      await mod.disable();
      setEnabled(false);
    } else {
      await mod.enable();
      setEnabled(true);
    }
    localStorage.setItem('autostart-configured', 'true');
  };

  if (!isTauri()) return null;
  if (loading) return <div className="flex items-center gap-3 px-3 py-2.5" aria-hidden="true"><Skeleton className="h-4 w-4 rounded" /><Skeleton className="h-3.5 w-40" /></div>;

  return (
    <ToggleSwitch
      checked={enabled}
      onChange={handleToggle}
      label="PC 시작 시 자동 실행"
      description="Windows 시작 시 트레이에서 자동으로 실행됩니다"
    />
  );
};
